/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/get_accessibility_results/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdGetAccessibilityResultsId } from "./constants";
import type { GetAccessibilityResultsResult } from "./types";
import { isGetAccessibilityResultsResult } from "./validators";

export const getAccessibilityResults = reactQueryFetcherAdapter(
  engagementAppGroupIdGetAccessibilityResultsId,
  (signal: AbortSignal, appGroupId: string, id: string, isDnd: boolean): Promise<GetAccessibilityResultsResult> => {
    return fetch(
      `/engagement/${appGroupId}/get_accessibility_results/${id}`,
      "GET",
      { is_dnd: isDnd },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetAccessibilityResultsResult
);
